export default [
  {
    name: 'identify',
    path: '/identify',
    component: { render: e => e('router-view') },
    children: [
      {
        name: 'identifyStatus',
        path: 'status',
        component: () => import(/* webpackChunkName: "identify_status" */ '@/pages/identify/status'),
        meta: {
          title: '认证状态页'
        }
      },
      {
        name: 'aggrementSign',
        path: 'aggrement',
        component: () => import(/* webpackChunkName: "identify_status" */ '@/pages/identify/aggrement'),
        meta: {
          title: '协议签署'
        }
      }
    ]
  }
];
